import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const RegistrationBanner = ({ onRegisterClick, patientEmail }) => {
  const { t } = useTranslation();

  return (
    <Alert 
      variant="info" 
      className="registration-banner"
      style={{
        backgroundColor: 'var(--main-color)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        margin: '0 0 20px 0',
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '10px'
      }}
    >
      <div style={{ flex: '1', minWidth: '200px' }}>
        <strong>{t('registration-banner.title', 'Registrieren Sie sich jetzt!')}</strong>
        <br />
        <small>
          {t('registration-banner.description', 'Erstellen Sie ein Konto, um Ihre Fortschritte zu verfolgen und personalisierte Inhalte zu erhalten.')}
        </small>
      </div>
      <Button
        variant="light"
        size="sm"
        onClick={onRegisterClick}
        style={{
          backgroundColor: 'white',
          color: 'var(--main-color)',
          border: 'none',
          fontWeight: 'bold',
          minWidth: '120px'
        }}
      >
        {t('registration-banner.register-button', 'Jetzt registrieren')}
      </Button>
    </Alert>
  );
};

export default RegistrationBanner;
